var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveDiscountCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M29.3337 16.0001C29.3337 23.3641 23.3643 29.3334 16.0003 29.3334C8.63633 29.3334 2.66699 23.3641 2.66699 16.0001C2.66699 8.63608 8.63633 2.66675 16.0003 2.66675C23.3643 2.66675 29.3337 8.63608 29.3337 16.0001Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9604 11.9601C12.1479 11.7729 12.4021 11.6677 12.6671 11.6677C12.9321 11.6677 13.1863 11.7729 13.3738 11.9601L16.0004 14.5868L18.6271 11.9601C18.7186 11.8619 18.829 11.7831 18.9517 11.7284C19.0744 11.6738 19.2068 11.6444 19.3411 11.642C19.4753 11.6396 19.6087 11.6643 19.7332 11.7146C19.8577 11.7649 19.9708 11.8398 20.0658 11.9347C20.1608 12.0297 20.2356 12.1428 20.2859 12.2673C20.3362 12.3918 20.3609 12.5252 20.3585 12.6595C20.3562 12.7938 20.3268 12.9262 20.2721 13.0488C20.2175 13.1715 20.1387 13.2819 20.0404 13.3735L17.4138 16.0001L20.0404 18.6268C20.2171 18.8164 20.3132 19.0671 20.3087 19.3262C20.3041 19.5852 20.1991 19.8324 20.0159 20.0156C19.8327 20.1988 19.5855 20.3038 19.3265 20.3084C19.0674 20.3129 18.8167 20.2168 18.6271 20.0401L16.0004 17.4135L13.3738 20.0401C13.1842 20.2168 12.9335 20.3129 12.6744 20.3084C12.4153 20.3038 12.1681 20.1988 11.9849 20.0156C11.8017 19.8324 11.6968 19.5852 11.6922 19.3262C11.6876 19.0671 11.7838 18.8164 11.9604 18.6268L14.5871 16.0001L11.9604 13.3735C11.7732 13.186 11.668 12.9318 11.668 12.6668C11.668 12.4018 11.7732 12.1476 11.9604 11.9601Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveDiscountCode);
export default __webpack_public_path__ + "static/media/remove-discount-code.aadca38971b6942320a0e3d3df3aa5b1.svg";
export { ForwardRef as ReactComponent };